import {IBizRedEnvelope, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {ARedEnvelope} from "@/views/editor/service/red_envelope/red_envelope";
import {EVipLevel} from "@/model/user_agent";

export interface IBusinessRedPacketSetMeta {
    enable: boolean;
    amount: number[];
    limit_pre_day: number;
}

export interface IBusinessRedPacketMeta {
    on_view: IBusinessRedPacketSetMeta;
    on_invite: IBusinessRedPacketSetMeta;
    area_limit: string[];
}

export default class RedPacket extends ARedEnvelope implements IBizRedEnvelope {
    readonly opt: IBusinessRedPacketMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as IBusinessRedPacketMeta;
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        if (this.editor.userAgent.authorizer().grant(EVipLevel.Professional)) return {
            active: [{value: 'view', label: '浏览红包'}, {value: 'invite', label: '邀请红包'}],
            preheating: [{value: 'view', label: '浏览红包'}, {value: 'invite', label: '邀请红包'}],
            finished: []
        }[status]
        else return []
    }

    resetMeta(status: EActivityStatus): IBusiness {
        this.meta.subs.length = 0
        this.meta.subs.push(...this.subs(status).map(s => s.value as string))
        return this;
    }

}